import { render, staticRenderFns } from "./Sample.vue?vue&type=template&id=0bac1601&scoped=true"
import script from "./Sample.vue?vue&type=script&lang=js"
export * from "./Sample.vue?vue&type=script&lang=js"
import style0 from "./Sample.vue?vue&type=style&index=0&id=0bac1601&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bac1601",
  null
  
)

export default component.exports